import { TableBody, TableCell, TableRow, Typography } from "@mui/material";

// ----------------------------------------------------------------------

export default function TableNotFound() {
	return (
		<TableBody>
			<TableRow>
				<TableCell align='center' colSpan={2} sx={{ py: 12 }}>
					<Typography color='text.primary' variant='h6'>
						{"No se encuentran transacciones"}
					</Typography>
				</TableCell>
			</TableRow>
		</TableBody>
	);
}
